import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class UtilsService {

  constructor() { }

  decodeToken(token: string) {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      window
        .atob(base64)
        .split('')
        .map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join('')
    );
    return JSON.parse(jsonPayload);
  }

  isValidToken(token: string | null) {
    if (token) {
      try {
        const decode = this.decodeToken(token);
        if (Date.now() < decode.exp * 1000) {
          return true;
        }
      } catch {
        return false;
      }
    }
    return false;
  }

  saveAuthToken(token: string, refresh?: string) {
    localStorage.setItem('authToken', token);
    refresh && localStorage.setItem('refreshToken', refresh);
  }

  clearAuth() {
    localStorage.removeItem('authToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('user');
  }
}
